﻿export const revealPassword = () => {
    
    const toggleInputType = input => {
        const type = input.type === 'password' ? 'text' : 'password';
        input.setAttribute('type', type);
    };

    const init = component => {
        const revelPasswordIcon = component.querySelector('.js-reveal-password');
        const passwordField = component.querySelector('.js-password-field');

        if (revelPasswordIcon && passwordField) {
            revelPasswordIcon.addEventListener('click', () => {
                toggleInputType(passwordField);
            });
        }
    };

    return {
        init,
        selector: '[data-component="password-reveal"]'
    };
};
